(function () {
  function parseEnd(root) {
    const endDate = root.dataset.endDate || '';
    const endTime = root.dataset.endTime || '00:00';
    const hideOnEnd = root.dataset.hide === 'true';

    const [mStr, dStr, yStr] = (endDate || '').split('-');
    const [hStr, minStr] = (endTime || '00:00').split(':');

    const m = parseInt(mStr, 10);
    const d = parseInt(dStr, 10);
    const y = parseInt(yStr, 10);
    const hh = parseInt(hStr, 10);
    const mm = parseInt(minStr, 10);

    if (!m || !d || !y || isNaN(hh) || isNaN(mm)) return { end: null, hideOnEnd };

    // Tránh lỗi parse date trên Safari/UTC: tạo Date theo (y, m-1, d, hh, mm)
    const end = new Date(y, m - 1, d, hh, mm, 0, 0);
    return { end, hideOnEnd };
  }

  function stopTimer(root) {
    if (root && root._countdownInterval) {
      clearInterval(root._countdownInterval);
      root._countdownInterval = null;
      root._countdownRunning = false;
    }
  }

  function startTimer(root) {
    if (!root || root._countdownRunning) return;

    const { end, hideOnEnd } = parseEnd(root);

    const display = root.querySelector('#countdown-display');
    const daysEl = root.querySelector('#countdown-days');
    const hoursEl = root.querySelector('#countdown-hours');
    const minutesEl = root.querySelector('#countdown-minutes');
    const secondsEl = root.querySelector('#countdown-seconds');

    function tick() {
      if (!end || isNaN(end.getTime())) {
        if (display) display.textContent = 'Invalid countdown date/time';
        return;
      }

      const now = new Date();
      const diff = end - now;

      if (diff <= 0) {
        stopTimer(root);
        root.style.display = hideOnEnd ? 'none' : 'flex';
        if (!hideOnEnd && display) display.textContent = '00:00:00';
        return;
      }

      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    tick();
    root._countdownInterval = setInterval(tick, 1000);
    root._countdownRunning = true;
  }

  function initCountdownTimer(container) {
    // Nếu bạn có nhiều timer, vẫn bắt được tất cả dù trùng id (khuyến nghị đổi sang class .countdown-timer)
    const timers = container.querySelectorAll('#countdown-timer, .countdown-timer');
    timers.forEach((el) => {
      stopTimer(el);   // clear cũ (nếu có) để tránh nhân bản interval sau mỗi lần Save
      startTimer(el);  // khởi tạo lại
    });
  }

  // Lần đầu load trang (preview iframe reload sau khi Save cũng chạy lại)
  document.addEventListener('DOMContentLoaded', function () {
    initCountdownTimer(document);
  });

  // Khi Shopify thay DOM section bằng AJAX trong Customize
  document.addEventListener('shopify:section:load', function (e) {
    initCountdownTimer(e.target);
  });

  // Khi bạn click chọn section trong editor (thường sau Save bạn hay quay lại click vào section)
  document.addEventListener('shopify:section:select', function (e) {
    initCountdownTimer(e.target);
  });

  // Khi section bị gỡ (Shopify unload) => clear interval
  document.addEventListener('shopify:section:unload', function (e) {
    const timers = e.target.querySelectorAll('#countdown-timer, .countdown-timer');
    timers.forEach(stopTimer);
  });

  // Kéo thả reorder cũng re-init cho chắc
  document.addEventListener('shopify:section:reorder', function () {
    initCountdownTimer(document);
  });

  // Trong design mode, nếu data-* thay đổi mà Shopify không reload section, tự quan sát và re-init
  if (window.Shopify && Shopify.designMode) {
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && (m.attributeName || '').startsWith('data-')) {
          const root = m.target.closest('#countdown-timer, .countdown-timer');
          if (root) {
            stopTimer(root);
            startTimer(root);
          }
        }
      }
    });

    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('#countdown-timer, .countdown-timer')
        .forEach((el) => mo.observe(el, { attributes: true }));
    });
  }
})();
